import { motion } from "framer-motion";
import { ArrowRight, Compass, Plane } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="py-20 bg-primary">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-2xl mx-auto"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary-foreground mb-4">
            Ready to Explore Paradise?
          </h2>
          <p className="text-primary-foreground/80 text-lg mb-8 leading-relaxed">
            Whether you need a reliable airport transfer or want to discover
            the best tours in the Dominican Republic — we've got you covered.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/tours">
              <Button
                size="lg"
                className="gap-2 font-semibold rounded-lg px-8 bg-white text-primary hover:bg-white/90"
              >
                <Compass className="w-5 h-5" />
                Explore Tours
              </Button>
            </Link>
            <Link to="/#booking">
              <Button
                size="lg"
                variant="outline"
                className="gap-2 font-semibold rounded-lg px-8 border-2 border-primary-foreground/40 text-primary-foreground hover:bg-primary-foreground hover:text-primary text-gray-950"
              >
                <Plane className="w-5 h-5" />
                Book Transfer
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
